import { useTranslation } from 'react-i18next';

const PageLengends = () => {
  const { t } = useTranslation();
  return (
    <div style={{ margin: '-60px 30% 40px', display: 'flex' }}>
      <div
        style={{
          margin: '0px auto',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: '#EB5757',
            margin: '0px 10px',
          }}
        />

        {/* Updated to use standard translation key for haulers */}
        <p style={{ marginTop: '-5px' }}> {t('std_asset_haulers')}</p>
      </div>
      <div
        style={{
          margin: '0px auto',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: '#497BFA',
            margin: '0px 10px',
          }}
        />

        {/* Updated to use standard translation key for loaders */}
        <p style={{ marginTop: '-5px' }}> {t('std_asset_loaders')}</p>
      </div>
      <div
        style={{
          margin: '0px auto',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: '#009161',
            margin: '0px 10px',
          }}
        />

        <p style={{ marginTop: '-5px' }}> Others</p>
      </div>
    </div>
  );
};

export default PageLengends;
